import { render, staticRenderFns } from "./book.vue?vue&type=template&id=626504a4&scoped=true&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"
import style0 from "./book.vue?vue&type=style&index=0&id=626504a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626504a4",
  null
  
)

component.options.__file = "book.vue"
export default component.exports